import { render, staticRenderFns } from "./GeneralDetails.vue?vue&type=template&id=1f8833c7&"
import script from "./GeneralDetails.vue?vue&type=script&lang=js&"
export * from "./GeneralDetails.vue?vue&type=script&lang=js&"
import style0 from "./GeneralDetails.vue?vue&type=style&index=0&id=1f8833c7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports